// extracted by mini-css-extract-plugin
module.exports = {"time-scale":"TimeScaleDdl-module__time-scale__2ZbFk"};